// extracted by mini-css-extract-plugin
export default {"destination":"destination_destination__UDNRR","address":"destination_address__DZVlY"};